import { FormattedMessage } from "react-intl";
import MainView from "views/MainView";
import { _H5Event, handleFromAppParams, publicPath } from "request";
import { useEffect } from "react";
import { useIntlContext } from "views/IntlContext";

export const AppleHealth = () => {
  const { switchLanguage, locale } = useIntlContext();
  useEffect(() => {
    const datas = {
      event: "GetTokenAndLanguage",
      pageName: "alexa",
      callback: (responseStr: any) => {
        const jsonData = handleFromAppParams(responseStr);
        switchLanguage?.(jsonData.lang);
      },
    };
    _H5Event(datas);
  }, []);

  return (
    <MainView backgroundClassName="bg-page dark:bg-black1b1f1e">
      <div className="pt-5 pr-9 pb-[80px] pl-6 flex flex-col">
        <p className="font-bold py-8 text-xl">
          <FormattedMessage id="helpCenter.appleHealth.title" />
        </p>
        <p className="mt-4 break-words">
          <FormattedMessage
            id="helpCenter.appleHealth.content1"
            values={{ name: <b>Apple Health</b> }}
          />
        </p>
        <img
          src={`${publicPath}/images/helpCenter/${locale}/applehealth/img01.png`}
          alt=""
          className="w-full max-w-[340px] h-fit rounded-md border border-solid border-gray-200 dark:border-white10 mt-6 "
        />
        <img
          src={`${publicPath}/images/helpCenter/${locale}/applehealth/img02.png`}
          alt=""
          className="w-full max-w-[340px] rounded-md border border-solid border-gray-200 dark:border-white10 mt-6 "
        />
        <p className="mt-10">
          <FormattedMessage
            id="helpCenter.appleHealth.content2"
            values={{
              allow: (
                <b>
                  <FormattedMessage id="helpCenter.appleHealth.content2.allow" />
                </b>
              ),
            }}
          />
        </p>
        <img
          src={`${publicPath}/images/helpCenter/${locale}/applehealth/img03.png`}
          alt=""
          className="w-full max-w-[340px] rounded-md border border-solid border-gray-200 dark:border-white10 mt-6 "
        />
        <img
          src={`${publicPath}/images/helpCenter/${locale}/applehealth/img04.png`}
          alt=""
          className="w-full max-w-[340px] rounded-md border border-solid border-gray-200 dark:border-white10 mt-6 "
        />
        <p className="mt-10">
          <FormattedMessage
            id="helpCenter.appleHealth.content3"
            values={{ name: <b>Apps &gt; Medcursor</b> }}
          />
        </p>
        <img
          src={`${publicPath}/images/helpCenter/${locale}/applehealth/img05.png`}
          alt=""
          className="w-full max-w-[340px] rounded-md border border-solid border-gray-200 dark:border-white10 mt-6 "
        />
        <p className="font-bold mt-20 text-xl">
          <FormattedMessage id="helpCenter.appleHealth.troubleshooting" />
        </p>
        <p className="font-bold mt-6 text-base">
          <FormattedMessage id="helpCenter.appleHealth.troubleshooting.question1" />
        </p>
        <ul className="list-disc pl-[1.5em] mt-4 text-gray666 dark:text-white60">
          <li className="mb-2">
            <FormattedMessage id="helpCenter.appleHealth.troubleshooting.question1.answer1" />
          </li>
          <li className="mb-2">
            <FormattedMessage id="helpCenter.appleHealth.troubleshooting.question1.answer2" />
          </li>
          <li className="mb-2">
            <FormattedMessage id="helpCenter.appleHealth.troubleshooting.question1.answer3" />
          </li>
        </ul>

        <p className="font-bold mt-6 text-base">
          <FormattedMessage id="helpCenter.appleHealth.troubleshooting.question2" />
        </p>
        <p className="mt-3 text-gray666 dark:text-white60">
          <FormattedMessage id="helpCenter.appleHealth.troubleshooting.question2.answer1" />
        </p>
      </div>
    </MainView>
  );
};
